import type { SVGProps } from 'react'

const StrategicInventoryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <ellipse cx="30" cy="30" rx="30" ry="30" fill="currentColor" />
    <path
      d="M41.25 25V36.25C41.25 39.0114 39.0114 41.25 36.25 41.25H23.75C20.9886 41.25 18.75 39.0114 18.75 36.25V25"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.75 18.75H18.25C17.1454 18.75 16.25 19.6454 16.25 20.75V23C16.25 24.1046 17.1454 25 18.25 25H41.75C42.8546 25 43.75 24.1046 43.75 23V20.75C43.75 19.6454 42.8546 18.75 41.75 18.75Z"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.5 30H32.5"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default StrategicInventoryIcon
